module.exports = __webpack_public_path__ + "img/BT.b4798b86.png";